import { inject, observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';

import { modelOf } from '../../../../prop-types';
import ConfigStore from '../../../../store/ConfigStore';
import TranslationStore from '../../../../store/TranslationStore';
import UIStore from '../../../../store/UIStore';

const CheckoutSummaryLogo = ({ configStore, translationStore, uiStore }) => {
  const checkoutLogo = translationStore.checkoutDesktopLogo;
  const logo = checkoutLogo.length > 0 ? checkoutLogo[0] : null;

  // Only show on desktop
  if (!logo || !uiStore.isDesktop) {
    return null;
  }

  return (
    <div className="CheckoutSummaryLogo">
      <Link to="/">
        <img
          alt={configStore.store.name}
          src={logo.image_path}
          width="300"
          height="100"
        />
      </Link>
    </div>
  );
};

CheckoutSummaryLogo.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  translationStore: modelOf(TranslationStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
};

export default inject(
  'configStore',
  'translationStore',
  'uiStore'
)(observer(CheckoutSummaryLogo));
